import { stringToNumber } from "../../../utils";

interface UseAvatarReturnData {
  nameInitial: string;
  avatarBackgroundColor: string;
  avatarTextColor: string;
}

export const useAvatar = (
  // userUuid: string, KAN-7376: Passing UserUuid here requires api changes in lots of places
  name: string
): UseAvatarReturnData => {
  const trimmedName = name.trim();
  const names = trimmedName.split(" ");
  const firstName = names[0] || "";
  const lastName = names.length > 1 ? names[names.length - 1] : "";
  const nameInitial = firstName[0].concat(lastName[0] || "");
  const numberFromUuid = stringToNumber(name);

  const allAvatarColours = [
    {
      background: "var(--color-green-100)",
      text: "var(--color-green-500)",
    },
    {
      background: "var(--color-coral-100)",
      text: "var(--color-coral-500)",
    },
    {
      background: "var(--color-indigo-100)",
      text: "var(--color-indigo-500)",
    },
    {
      background: "var(--color-goldenrod-100)",
      text: "var(--color-goldenrod-500)",
    },
    {
      background: "var(--color-red-100)",
      text: "var(--color-red-500)",
    },
  ];

  const avatarColour = allAvatarColours[numberFromUuid % 5];

  return {
    nameInitial,
    avatarBackgroundColor: avatarColour.background,
    avatarTextColor: avatarColour.text,
  };
};
